module.exports = __webpack_public_path__ + "assets/phusion-passenger.7fef283a.svg";